import { gql } from '@apollo/client';

export const TRIGGER_CONFIG_FILE_UPDATE = gql`
  mutation TriggerConfigFileUpdate($deviceId: ID!) {
    triggerConfigFileUpdate(deviceId: $deviceId) {
      executionName
    }
  }
`;
